import OnboardingV2 from './Onboarding/Onboarding';
import LegacyOnboarding from './Onboarding/LegacyOnboarding';
import { useIsNewSocialMediaIntegration } from 'hooks/useIsNewSocialMediaIntegration';
import { useOnboardingContext } from 'hooks';
import { useEffect } from 'react';

const Onboarding = () => {
  const {
    data: isNewSocialMediaIntegrationData,
    loading: isNewSocialMediaIntegrationLoading,
    refetch: refetchIsNewSocialMediaIntegration,
  } = useIsNewSocialMediaIntegration();
  const isNewSocialMediaIntegration =
    isNewSocialMediaIntegrationData?.canUseSocialMediaIntegration
      ?.canUseNewIntegration;

  const { showOnboardingModal } = useOnboardingContext();

  useEffect(() => {
    if (showOnboardingModal) {
      refetchIsNewSocialMediaIntegration();
    }
  }, [showOnboardingModal, refetchIsNewSocialMediaIntegration]);

  if (isNewSocialMediaIntegrationLoading) {
    return null;
  }

  if (isNewSocialMediaIntegration) {
    return <OnboardingV2 />;
  }

  return <LegacyOnboarding />;
};

export default Onboarding;
